<div class="flex timing-container">
	<vb-lxp-timing-tower-full
		class="grow-1"
		[activeClass]="'active-tower-item'"
		[selectedClasses]="selectedClasses()"
	></vb-lxp-timing-tower-full>
	<vb-lxp-panel
		[panelKey]="'map'"
		[defaultOpenState]="true"
		[panelClass]="'map-panel'"
		[panelHeaderClass]="'map-panel-header'"
		[panelBodyClass]="'block h-full'"
		[disablePin]="true"
	>
		<div header class="pr-14">
			<span>Cota Track Map</span>
			<button
				class="border-1 border-border-default p-2 rounded ml-2 cursor-pointer hover:bg-surface-container-high"
				(click)="openFullMapPage()"
				target="_blank"
				[title]="'Full Map'"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					class="bi bi-arrows-fullscreen"
					viewBox="0 0 16 16"
				>
					<path
						fill-rule="evenodd"
						d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
					/>
				</svg>
			</button>
		</div>
		<div body class="h-full">
			<vb-lxp-map
				[showLabels]="false"
				[track]="'cota_track.geojson'"
				[selectedCarIds]="timingTowerService.activeList()"
			></vb-lxp-map>
		</div>
	</vb-lxp-panel>
</div>
